import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    margin-top: ${theme.spacing(2)}px;
  `,
  visible: css`
    display: block;
  `,
  hidden: css`
    display: none;
  `,
  complimentContainer: css`
    display: flex;
    justify-content: stretch;
    flex-wrap: nowrap;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none /* IE and Edge */;
    scrollbar-width: none /* Firefox */;
  `,
}
